<template>
  <div
    v-if="tableState.showTable"
    class="positioner"
  >
    <power-table
      :row-data="tableState.dataTable"
      :header-props="headerProps()"
      :active="active"
      :is-training="isTraining"
      :is-start-list="tableState.isStartList"
      :show-discipline-icon="showDisciplineIcon"
      :show-ranking-points-ssm="showRankingPoints"
      :special-record="specialRecord"
      class="transform-origin-top-center"
      @mousedown="oneClick"
      @touchstart="oneClick"
    />
  </div>
</template>

<script lang="ts">
import {
  requestManager,
  modes,
  playersManager,
  timeManager,
  minigameConfig
} from '@powerplay/core-minigames'
import { PowerTable } from '@powerplay/core-minigames-ui-ssm'
import { pathAssetsCoreUi } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import { player } from '@/app/entities/athlete/player/Player'
import { gameConfig } from '@/app/config'
import { wind } from '@/app/entities/athlete/Wind'
import {
  tableState,
  type TableState
} from '@/stores'

export default defineComponent({
  name: 'DataTable',
  components: {
    PowerTable
  },
  data() {

    return {
      active: false,
      specialRecord: '',
      isPB: false,
      firstClick: false,
      tableState: tableState()
    }

  },
  computed: {
    isTraining() {

      return modes.isTrainingMode()

    },
    showDisciplineIcon() {

      return modes.isBossCompetition()

    },
    showRankingPoints() {

      return !modes.isBossCompetition() && !modes.isEventBossFight()

    }
  },
  watch: {
    tableState: {
      handler(value: TableState) {

        console.log(value)
        setTimeout(() => {

          this.active = value.activeState

        }, 10)

      },
      deep: true
    },
  },
  methods: {
    oneClick(event: Event) {

      if (tableState().activeState) event.stopPropagation()

    },
    headerProps() {

      let personalBest = playersManager.getPlayer().personalBest
      if (personalBest === 0 && player.finalTime !== minigameConfig.dnfValue) personalBest = minigameConfig.dnfValue
      const result = Math.ceil(player.finalTime * 100) / 100
      let personalBestValue = personalBest

      if (tableState().resultText === 'finalStandings' && !modes.isTournament()) {

        if (personalBest >= result) {

          this.specialRecord = 'PB'
          this.isPB = true

        }
        if (gameConfig.worldRecord >= result) this.specialRecord = 'WR'
        personalBestValue = personalBest > result ? result : personalBest

      }
      let headerTableText = {}
      if (tableState().resultText !== 'startList') {

        headerTableText = {
          col3: this.$t('time')
        }

      }

      const pbObject = {
        showNew: this.isPB,
        value: personalBestValue === 0 ? '-' : timeManager.getTimeInFormatFromSeconds(personalBestValue, 2)
      }
      if (modes.isTournament()) {

        pbObject.showNew = false
        pbObject.value = ''

      }

      return {
        discipline: {
          name: this.$t(`disciplineName${requestManager.disciplineID}`),
          image: `${pathAssetsCoreUi}/table/attribute-icon/disc-ico-light-01.svg`
        },
        competitonType: this.$t(tableState().competitionText),
        resultType: this.$t(tableState().resultText),
        wind: {
          show: tableState().resultText === 'finalStandings' ? true : false,
          value: `${wind.getValueWithSignAsString()}`
        },
        headerTableText,
        personalBest: pbObject,
      }

    }
  }

})

</script>

<style scoped lang="less">
.positioner {
  position: absolute;
  top: 13%;
  left: 50%;
  transform: translateX(-50%);

  .transform-origin-top-center {
      transform-origin: top center;
  }
}
</style>
